import { Component } from '@angular/core';
import { BasePage } from '../../../shared/components/base-page.component';

@Component({
    selector: 'builder-register-confirm-page',
    standalone: true,
    imports: [...BasePage.BaseImports],
    templateUrl: './AccountConfirmPage.html',
    styleUrl: './AccountConfirmPage.css',
})

export class AccountConfirmPage implements BasePage
{
}
